import { RelatedAccountsResponse } from '../../Applicant.types';
import { ApplicantActivity } from '../ApplicantActivity';
import { Condition } from '../ApplicantConditions/ApplicantConditions.types';
import { ApplicantDocument } from '../ApplicantDocument';
import { ApplicantHeader } from '../ApplicantHeader';
import { ApplicantInfoWrapper } from '../ApplicantInfoWrapper';
import { ApplicantRelatedAccounts } from '../ApplicantRelatedAccounts';
import { ApplicantTags } from '../ApplicantTags';
import { DueDiligence } from '../DueDiligence';
import { PrintApplicantConditions } from '../PrintApplicantConditions';
import { PrintApplicationStatus } from '../PrintApplicationStatus';

interface PrintAggregateProps {
    printDateTime: string;
    printUrl: string;
    relatedAccounts: RelatedAccountsResponse | null;
    openConditions?: Condition[];
    closedConditions?: Condition[];
    deletedConditions?: Condition[];
}

const SectionMeta = ({ printDateTime, printUrl }: { printDateTime: string; printUrl: string }) => (
    <div className="print-section-meta">
        <span className="print-section-meta-datetime">{printDateTime}</span>
        <a className="print-section-meta-link" href={printUrl}>{printUrl}</a>
    </div>
);

export const PrintAggregate = ({
    printDateTime,
    printUrl,
    relatedAccounts,
    openConditions = [],
    closedConditions = [],
    deletedConditions = [],
}: PrintAggregateProps) => (
    <div id="printAggregate">
        {/* Cover page */}
        <div className="print-cover">
            <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
            <div className="print-cover-banner">
                Have an issue with this report? Open the link above to view the live application in the ORP.
            </div>
            <div className="print-cover-header">
                <ApplicantHeader />
            </div>
            <div className="print-section-heading" style={{ pageBreakBefore: 'avoid', breakBefore: 'avoid' }}>Application Status</div>
            <PrintApplicationStatus />
        </div>

        {/* One tab per page */}
        <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
        <div className="print-section-heading">Application</div>
        <ApplicantInfoWrapper />

        <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
        <div className="print-section-heading">Due Diligence Data</div>
        <DueDiligence idPrefix="print-" />

        <div className="print-landscape-section">
            <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
            <div className="print-section-heading">Documents</div>
            <p className="print-documents-note">
                Visit the ORP to view these files: <a href={printUrl}>{printUrl}</a>
            </p>
            <ApplicantDocument />
        </div>

        <div className="print-landscape-section">
            <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
            <div className="print-section-heading">Tasks/Conditions</div>
            <PrintApplicantConditions
                openConditions={openConditions}
                closedConditions={closedConditions}
                deletedConditions={deletedConditions}
            />
        </div>

        <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
        <div className="print-section-heading">Tags / Signals</div>
        <ApplicantTags />

        <div className="print-landscape-section">
            <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
            <div className="print-section-heading">Related Entities</div>
            <ApplicantRelatedAccounts
                loadPayAccounts={relatedAccounts?.loadPayAccounts ?? []}
                originationsApplicants={relatedAccounts?.originationsApplicants ?? []}
                deltaClients={relatedAccounts?.deltaClients ?? []}
                unavailableSources={relatedAccounts?.unavailableSources ?? []}
                isLoading={false}
            />
        </div>

        <div className="print-landscape-section">
            <SectionMeta printDateTime={printDateTime} printUrl={printUrl} />
            <div className="print-section-heading">Activity</div>
            <ApplicantActivity isPrintView />
        </div>
    </div>
);
